import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { Callouts, Callout } from "@zendesk/self-service-components";

function Notifications({ notifications }) {
  return (
    <Callouts floating>
      {notifications.map(notification => {
        return (
          <Callout
            key={notification.id}
            type={notification.type}
            testId={`notification-${notification.type}`}
          >
            {notification.message}
          </Callout>
        );
      })}
    </Callouts>
  );
}

Notifications.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["error", "success"]).isRequired,
      message: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default connect((state, ownProps) => ({
  notifications: state.notifications.notifications,
}))(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notifications/index.js